import React from "react";
import Header from "../../components/user/Header";
import Footer from "../../components/user/Footer";
import PageBanner from "../../components/user/PageBanner";

const PublicLayout = ({ children, title, subtitle }) => {
	return (
		<>
			<Header />
			{title && <PageBanner title={title} subtitle={subtitle} />}
			<main className="max-w-8xl mx-auto px-4 py-10">{children}</main>
			<Footer />
		</>
	);
};

export default PublicLayout;
